<template>
    <b-container fluid>
      <span v-if="debug === 'true' || debug === true">{{version}}</span>
      <loading
      :active.sync="loading"
      :can-cancel="false"
      :is-full-page="true"
    ></loading>
      <div>
        <filtros-busqueda :empleados.sync="empleados"
                          @buscar="buscarDatosBloques"
                          :tipo-busqueda="tipoBusqueda"/>
        <b-button :disabled="!excel" @click="exportarExcel()" variant="info">Exportar Excel</b-button>
      </div>
      <div>
        <b-alert  variant="success"
                  show
        >
          <span style="margin-right: 30%;" >Bloques trabajados en el periodo {{ totalBloques  }}</span>
          <span style="margin-right: 10%;" >Total a recibir: {{totalPagoArecibir | moneda}} </span>
        </b-alert>
      </div>
    <div class="container">

      <br/>
        <div class="col">
          <b-table
              id="Pendientes"
              thead-tr-class="columnas"
              :items="datos"
              :fields="columnas"
              :per-page="$registrosPorPagina"
              :current-page="paginaActual"
              responsive
              stacked="md"
              class="parrafos"
              no-footer-sorting
              foot-row-variant="secondary"
              show-empty
          >
            <template v-slot:cell(fechaBloque)="row">
              {{ row.item.fechaBloque|formatoFechaCorta }}
            </template>
            <template #empty="scope">
              <b-col v-if="!loader">
                <b-alert v-if="datos.length === 0" variant="warning" show>No hay datos</b-alert>
              </b-col>
              <div align="center" v-if="loader">
                <b-spinner variant="primary" label="Spinning"></b-spinner>
              </div>
            </template>
          </b-table>

          <b-pagination
              v-if="datos !== undefined && datos.length > 10"
              align="center"
              v-model="paginaActual"
              :total-rows="datos.length"
              :per-page="$registrosPorPagina"
          ></b-pagination>

        </div>

    </div>
      <br/>
      <br/>
      <br/>
  </b-container>
</template>
<script>
import FiltrosBusqueda from "@/components/Compensaciones/FiltrosBusqueda";
import XLSX from 'xlsx';
export default{
  components: {FiltrosBusqueda},
  props: {
        empleados: Array,
        quincena: null
    },
    data(){
        return{
          version: process.env.VUE_APP_ENV_VERSION,
          debug: false,
          loader: false,
          especialidad: null,
          idEmpleado: null,
          totalPagoArecibir: 0,
          datos:[],
          columnas:[
            {key: "fechaBloque", label: "Fecha", sortable: true},
            {key: "clinica", label: "Clínica", sortable: true},
            {key: "numeroDeBloques", label: "Numero de Bloques", sortable: true}
          ],
          paginaActual:1,
          tipoBusqueda: "quincena",
          totalBloques: 0,
          filtros: null,
          loading:false,
          excel: false,
        }
    },
    created() {
      this.debug = this.$localStorageService.getDebug();
    },
    methods: {
      exportarExcel(){
        this.loading = true
        const fecha = this.$moment(new Date()).format('l')
      const newDate = fecha.split("/")
      var dia = newDate[0];
      var mes = newDate[1];
      var anio = newDate[2];

       

      let datosExcel = [];
       this.datos.forEach((element) => {
          let datos = {
            "Empleado": element.nombreEspecialista,
            "Fecha de bloque": element.fechaBloque,
            "Clínica": element.clinica,
            "Número de bloques":element.numeroDeBloques
        }
        datosExcel.push(datos);
       });

       datosExcel.push("");
       datosExcel.push( {
           "Bloques trabajados": this.totalBloques, 
           "Total a recibir": "$" + this.totalPagoArecibir
        });
     
       let data = XLSX.utils.json_to_sheet(datosExcel)
      const workbook = XLSX.utils.book_new()
      const filename = 'pago_garantizado_'+dia+'_'+mes+'_'+anio;
      XLSX.utils.book_append_sheet(workbook, data, filename)
      XLSX.writeFile(workbook, `${filename}.xlsx`)
      this.loading = false
      },
        buscarDatosBloques(filtro) {
          this.paginaActual = 1;
          this.excel = false;
        this.filtros = filtro
        this.loader = true
        this.datos = [];
        this.totalPagoArecibir = 0.0;
        this.totalBloques = 0;
        this.$http.post(this.$api + 'comisiones/comision_bloque/empleado/pagoGarantizado', filtro).then(respuesta => {
            if (respuesta.data.data) {
              let datos = respuesta.data.data;

              if (datos !== undefined && datos !== null && datos.fechasBloques !== undefined && datos.fechasBloques !== null) {
                this.datos = datos.fechasBloques;
                this.totalPagoArecibir = datos.totalPagoBloques;

                this.datos.forEach(d => {
                  this.totalBloques += d.numeroDeBloques
                })
                this.excel = true;
              }

            }
        }).finally(() => {
              this.loader = false;
            })
        }
    }
}
</script>
<style>
#h1{
    text-align: center;
    font-size: 25px;
    color: rgb(80, 180, 220);
    font-weight: bold;
}
#tablaIzquierda{
    float: left;
    padding: 10px;
    width: 300px;
    margin: 20px;
}
#tablaDerecha{
    float: left;
    padding: 10px;
    width: 300px;
    margin: 20px;
    margin-left: 200px;
}
</style>